import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import moment from "moment";

const QuizResultNotice = () => {
  const location = useLocation();
  const navigate = useNavigate();
const [attemptCount,setAttemptCount]=useState(0)
  const { attemptedCount = 0, declarationDate } = location.state || {};
  

//   if (!attemptedCount || !declarationDate) {
//     return (
//       <div className="text-center mt-5">
//         <h4>Invalid access. Please complete the quiz first.</h4>
//         <Button className="mt-3" onClick={() => navigate("/")}>Go to Home</Button>
//       </div>
//     );
//   }
useEffect(()=>{
  setAttemptCount(attemptedCount)
},[attemptedCount])
console.log("attempted count-----> ",attemptCount)
  // Convert to formatted date (30 June 2025)
  const formattedDate = moment(declarationDate).format("D MMMM YYYY"); // English
  const hindiMonthMap = {
    January: "जनवरी", February: "फ़रवरी", March: "मार्च",
    April: "अप्रैल", May: "मई", June: "जून",
    July: "जुलाई", August: "अगस्त", September: "सितंबर",
    October: "अक्टूबर", November: "नवंबर", December: "दिसंबर"
  };

  const [day, month, year] = formattedDate.split(" ");
  const hindiDate = `${day} ${hindiMonthMap[month]} ${year}`;

  return (
    <div className="container mt-5 p-4" style={{ maxWidth: "800px" , height:"65vh" }}>
      <div className="card shadow-lg border-0 p-4 text-center">
        <h2 className="mb-4">Exam Submitted Successfully ✅</h2>
        <div className="fs-5 mb-3 d-flex align-items-center justify-content-center">
          <h4>Questions Attempted:</h4> <h4 className="px-2">{attemptCount}</h4> 
        </div>
    
        <div className="alert alert-warning fw-semibold" style={{ fontSize: "1.1rem" }}>
          📢 The result will be declared on <span className="text-primary">{formattedDate}</span>.
          <br />
          📢 परिणाम <span className="text-danger">{hindiDate}</span> को घोषित किया जाएगा।
        </div>

        <Button variant="outline-primary" onClick={() => navigate("/student/student-dashboard")}>
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default QuizResultNotice;
